import { Directive, ElementRef, OnInit } from '@angular/core';

/**
 * Directive to ignore form fields from password managers.
 * https://www.stefanjudis.com/snippets/turn-off-password-managers/
 */
@Directive({
  selector: '[pm-ignore]',
  standalone: false,
})
export class PmIgnoreDirective implements OnInit {
  constructor(private readonly el: ElementRef<HTMLElement>) {}

  ngOnInit() {
    this.el.nativeElement.setAttribute('data-1p-ignore', ''); // 1password
    this.el.nativeElement.setAttribute('data-lpignore', 'true'); // LastPass
    this.el.nativeElement.setAttribute('data-form-type', 'other'); // Dashlane
    this.el.nativeElement.setAttribute('data-bwignore', ''); // Bitwarden
  }
}
